module.exports = __webpack_public_path__ + "static/media/chat.2a6b6a44.svg";